import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import React from 'react';
import { InfoIconContainer } from './style';

export const infoIcon = (
  <InfoIconContainer>
    <InfoOutlinedIcon fontSize={'inherit'} />
  </InfoIconContainer>
);
